import React from 'react';
import createSvgIcon from '../createSvgIcon';

export default createSvgIcon(
  <polygon points="6.7,14.7 8.1,13.3 3.8,9 16,9 16,7 3.8,7 8.1,2.7 6.7,1.3 0,8 " />,
  'ArrowTailLeft',
);
